export default "__VITE_ASSET__DoWR6JkL__"